import { render, staticRenderFns } from "./BmPedidos.vue?vue&type=template&id=48bfa336&"
import script from "./BmPedidos.vue?vue&type=script&lang=js&"
export * from "./BmPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports